






























































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
   
 
     import BHUsers from '../../../store/entities/bhusers'
    
    @Component
    
    export default class EditBHUser extends AbpBase{
        /*itype:2;
        opttype:0;
        points:1;
        sources:"";*/
        @Prop({type:Boolean,default:false}) value:boolean;
        user:BHUsers=new BHUsers();
       
        data() {
            return {
                 itype:2,
                 opttype:0,
                 points:1,
                sources:""
            }
        }
    
     
        created(){
            
        }
        get carea_id(){

             return this.$store.state.bhusers.carea_id;
        }
        set carea_id(val:number){
             this.$store.commit('bhusers/change_carea_id',val);
        }
         get sarea_id(){
 
             return this.$store.state.bhusers.sarea_id;
        }
        set sarea_id(val:number){
             this.$store.commit('bhusers/change_sarea_id',val);
        }
         get qarea_id(){

             return this.$store.state.bhusers.qarea_id;
        }
        set qarea_id(val:number){
             this.$store.commit('bhusers/change_qarea_id',val);
        }
     
        

 


      
        save(){
              var th=this;
             
             var points=this.$data.points;
             let sources=this.$data. sources;

                 if(points<=0){
                     this.$Message.error("分值不能<=0");
                    return false;
                 }
                  if(sources==""){
                    this.$Message.error("原因或备注不能为空");
                    return false;
                 }
                 sources="积分操作("+sources+")";
                var qrcode="";
                if(this.user.qrcode.length>0){
                    qrcode=this.user.qrcode;
                }
                else if(this.user.integralCard.length>0){
                    qrcode=this.user.integralCard;
                }
               else if(this.user.otherCard.length>0){
                    qrcode=this.user.otherCard;
                }
                if(qrcode.length<=0){

                    this.$Message.error("卡号信息异常");
                    return false;
                }
                 var param={
  "qrcode": qrcode,
  "itype": this.$data.itype,
  "opttype": this.$data.opttype,
  "points": points,
  "sources": sources
};     
 
     let lt=   this.$store.dispatch({
      type: "bhusers/updateIncreasePoints",
      data: param,
    }).then(res => {
       if(res.stateCode==0){

           (th.$refs.userForm as any).resetFields();
                    th.$emit('save-success');
                    th.$emit('input',false);
                      this.$Message.success(res.message)     
       }else{

          this.$Message.error(res.message)     
       }
              
 
    });
  
             
  }
        cancel(){
            (this.$refs.userForm as any).resetFields();
            this.$emit('input',false);
        }
        visibleChange(value:boolean){
           
            if(!value){
                this.$emit('input',value);
            }else{
                this.user=Util.extend(true,{},this.$store.state.bhusers.editUser);
                        
            }
        }
        /*Rule={
               sources:[{required: true,message:this.L('FieldIsRequired',undefined,this.L('Username')),trigger: 'blur'}],
               points:[{type:'number', required: true,message:'请选择小区',trigger: 'change'}],
              // qrcode:[{required: true,message:'请输入易腐垃圾卡号',trigger: 'blur'}],  
               // integralCard:[{required: true,message:'请输入积分卡号',trigger: 'blur'}],  
               // otherCard:[{required: true,message:'请输入其他垃圾卡号',trigger: 'blur'}],  
        }*/


    }

